if (!customElements.get('variant-swatch-slider')) {
  customElements.define(
    'variant-swatch-slider',
    class VariantSwatchSlider extends HTMLElement {
      constructor() {
        super();
        this.swiperEl = null;
        this.sliderInstance = false;
      }

      get slider() {
        return this.sliderInstance?.slider || null;
      }

      connectedCallback() {
        this.swiperEl = this.querySelector('.swiper');
        if (!this.swiperEl) return;
        this.classList.add('is-initializing');
        const doInit = () => {
          requestAnimationFrame(() => {
            requestAnimationFrame(() => this.init.bind(this)());
          });
        };
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', doInit);
        } else {
          doInit();
        }
      }

      init() {
        if (!this.swiperEl || typeof window.FoxTheme === 'undefined' || this.sliderInstance) return;

        const gap = 16;

        this.sliderOptions = {
          slidesPerView: 'auto',
          spaceBetween: gap,
          loop: false,
          freeMode: true,
          grabCursor: true,
          allowTouchMove: true,
          passiveListeners: false,
          speed: 450,
          resistanceRatio: 0,
          pagination: false,
          threshold: 2,
          focusableElements: 'select, option, textarea, button, video',
          navigation: {
            prevEl: this.querySelector('.swiper-button-prev'),
            nextEl: this.querySelector('.swiper-button-next'),
          },
        };

        this.sliderInstance = new window.FoxTheme.Carousel(this.swiperEl, this.sliderOptions);
        this.sliderInstance.init();
        this.classList.remove('is-initializing');
      }

      disconnectedCallback() {
        if (this.sliderInstance && this.sliderInstance.slider) {
          this.sliderInstance.slider.destroy();
          this.sliderInstance = false;
        }
      }
    }
  );
}
